import * as ChannelService from '@channel.io/channel-web-sdk-loader';
import { useMemo } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import { ampli } from '../../ampli';
import { IProduct } from '../../interfaces/Product.interfaces';
import { postMessageToRN } from '../../utils/RNCommunicator/postMessageToRN.util';
import { getGeneralMarketDetailPageURL } from '../../utils/getter/getProductDetailPageURL.util';
import { usePostInquiryTractorMutation } from '../api/inquiry/mutations/usePostInquiryTractor.mutation';
import { useCheckUserLoggedIn } from '../user/useCheckUserLoggedIn';

interface IUseHandleProductInquiryProps {
  product: IProduct;
  category: 'PLUVA' | 'PARTNER';
  page: 'PDP' | 'PLP';
}

interface IUseHandleProductInquiryReturn {
  handleProductInquiryButtonClick: () => void;
}

export const useHandleProductInquiry = ({
  product,
  category,
  page,
}: IUseHandleProductInquiryProps): IUseHandleProductInquiryReturn => {
  const location = useLocation();
  const { isUserLoggedIn } = useCheckUserLoggedIn();
  const { mutate: postUserInquiryTractor } = usePostInquiryTractorMutation();

  const productDetailURL = useMemo(() => {
    if (!product) {
      return '';
    }

    return `${window.location.origin}${getGeneralMarketDetailPageURL(product)}`;
  }, [product]);

  const handleButtonClick = () => {
    if (product) {
      if (category === 'PLUVA') {
        ampli.마켓플루바매물전화상담버튼클릭({
          '게시글 제목': product?.title ?? '',
          '매물 코드': product?.code,
          page_type: page,
        });
      } else {
        ampli.마켓파트너매물전화상담버튼클릭({
          '게시글 제목': product?.title ?? '',
          '매물 코드': product?.code,
          page_type: page,
        });
      }
    }

    ChannelService.track('ConsultButtonClick');
    ReactGA.event('pvm_product_inquiry', { category: 'pvm', action: 'pvm_product_inquiry' });

    if (window.ReactNativeWebView && page === 'PDP') {
      postMessageToRN({
        messageKey: 'flarelane_trackEvent',
        messageParam: 'pvm_pdp_inquiry_button_click',
        messageData: {
          brandName: product.machine.brand.name,
          machineModel: product.machine.model,
          productDetailPageURL: productDetailURL,
        },
      });
    }

    if (isUserLoggedIn) {
      postUserInquiryTractor({ reqBody: { productId: product.id } });

      if (window.ReactNativeWebView) {
        postMessageToRN({ messageKey: 'link', messageParam: 'tel:07041382449' });
      } else {
        window.location.href = 'tel:07041382449';
      }
    } else {
      sessionStorage.setItem('blockedPageURL', location.pathname);
      sessionStorage.setItem('failedInquiryTractorId', product.id);
    }
  };

  return {
    handleProductInquiryButtonClick: handleButtonClick,
  };
};
